import * as Yup from "yup"
import { warranty } from "@components/Intl/messages/warranty"

const regex = new RegExp(
  /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/
)
export const schema = {
  nl: Yup.object().shape({
    firstName: Yup.string().required(`Voornaam ${warranty.nl.isRequired}`),
    lastName: Yup.string().required(`Achternaam ${warranty.nl.isRequired}`),
    purchaseDate: Yup.string()
      .matches(regex, warranty.nl.purchaseDateError)
      .required(`Aankoopdatum ${warranty.nl.isRequired}`),
    email: Yup.string()
      .required(`Email ${warranty.nl.isRequired}`)
      .email(warranty.nl.emailError),
  }),
  en: Yup.object().shape({
    firstName: Yup.string().required(`First name ${warranty.en.isRequired}`),
    lastName: Yup.string().required(`Last name ${warranty.en.isRequired}`),
    purchaseDate: Yup.string()
      .matches(regex, warranty.en.purchaseDateError)
      .required(`Purchase date ${warranty.en.isRequired}`),
    email: Yup.string()
      .required(`Email ${warranty.en.isRequired}`)
      .email(warranty.en.emailError),
  }),
}
